import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CheckPasswordTokenComponent } from '@common/components/reset-password/check-password-token/check-password-token.component';

import { MainComponent } from './main/main.component';

const routes: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'main',
    component: MainComponent,
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
  },
  { path: 'password_reset', component: CheckPasswordTokenComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
